import React, { useState, useEffect } from "react"

import fetchJsonp from "fetch-jsonp"
import SmartFeedJobAlerts from "./SmartFeedJobAlerts"

import { Link } from "gatsby"

import "url-search-params-polyfill"

require("es6-promise").polyfill()

let prevCount = 0
let currentCount = 0
let keywordTime = null

const setVacancyLoadingBackup = function setVacancyLoadingBackup(
  loading,
  vacancyLoading
) {
  if (loading) {
    vacancyLoading = true
    return true
  }

  vacancyLoading = false
  return false
}

const SmartFeedFiltersComponent = ({
  vacancyLoading = true,
  apiKey = "",
  gdprKey = "",
  region = "",
  category = "",
  group = false,
  ryi = false,
  CompanyGroupName = "",
  VacancyPageBaseURL = "",
  ReturnToSearchURL = "",
  contentDataData = [],
  setVacancyLoading = setVacancyLoadingBackup,
}) => {
  const id = 1
  const [vacancy, setVacancy] = useState([])
  const [vacancyTitle, setVacancyTitle] = useState("Loading vacancies...")
  const [isIinitialLoad, setIsIinitialLoad] = useState(true)
  const [initialLoading, setInitialLoading] = useState(true)
  const [vacancyLocation, setVacancyLocation] = useState([])

  // Filter States
  const [locationFilter, setLocationFilter] = useState([])
  const [regionFilter, setRegionFilter] = useState([])
  const [categoryFilter, setCategoryFilter] = useState([])
  const [industryFilter, setIndustryFilter] = useState([])
  const [postingTypeFilter, setPostingTypeFilter] = useState([])
  const [jobTypeFilter, setJobTypeFilter] = useState([])
  const [keywordFilter, setKeywordFilter] = useState([])
  const [autoCompleteFilter, setAutoCompleteFilter] = useState([])
  const [autocompleteListHide, setAutocompleteListHide] = useState(true)
  const [filterState, setFilterState] = useState({})
  const [vacsCount, setVacsCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const [loadMoreText, setLoadMoreText] = useState(false)

  // Button filters
  const [careersNavState, setCareersNavState] = useState(
    ryi ? "register" : "careers"
  )

  const addActiveClassnameToNav = function addActiveClassnameToNav(stateName) {
    if (stateName === careersNavState) {
      return "VF_Nav_Item_Active"
    }

    return ""
  }

  let groupOrIdParam = "id"

  if (group) {
    groupOrIdParam = "group"
  }

  function removeDuplicates(array) {
    return array.filter((a, b) => array.indexOf(a) === b)
  }

  const fetchFilters = async (name, setState, label) => {
    if (!region) {
      region = "all"
    }
    try {
      fetchJsonp(
        "https://sf.vacancy-filler.co.uk/CareerPage/" +
          name +
          "?" +
          groupOrIdParam +
          "=" +
          apiKey +
          "&region=" +
          region
      )
        .then(function(response) {
          return response.json()
        })
        .then(function(jsonList) {
          let temp = ["All " + label]
          // let temp = ["- Filter by " + label + " -"]

          setState(temp.concat(removeDuplicates(jsonList)))

          setVacancyLoading(false)
        })
        .catch(function(ex) {
          setLoading(false)
          setVacancyLoading(false)
          console.error(ex, "error")
        })
    } catch (error) {
      setLoading(false)
      setVacancyLoading(false)
      console.error(error.message, "error")
    }
  }

  const fetchVacancies = async (
    state,
    name,
    e,
    loadMore,
    postingTypeSelection
  ) => {
    let postingTypeSelectionValue = careersNavState

    if (careersNavState !== postingTypeSelection && postingTypeSelection) {
      postingTypeSelectionValue = postingTypeSelection
    }

    // State of filters, Name of searched filter, event, load more boolean
    setLoadMoreText("Loading.....")

    if (name) {
      prevCount = 0
      currentCount = 0
    }

    let temp = state

    if (region) {
      temp.region = region
    }
    if (category) {
      temp.category = category
    }

    if (name) {
      if (e) {
        if (e.target && e.target.value.includes(name)) {
          e.target.value = ""
        }
      }

      if (name === "autocomplete") {
        temp.latitude = e.lat
        temp.longitude = e.long
        temp.distance = e.distance
        temp.unit = "Miles"
      } else if (name === "location") {
        if (e.target.value.includes("All ")) {
          delete temp.location
        } else {
          temp.location = e.target.value
        }
      } else if (name === "keywords") {
        temp.keywords = e.target.value
      } else if (name === "region") {
        if (e.target.value.includes("All ")) {
          delete temp.region
        } else {
          temp.region = e.target.value
        }
      } else if (name === "category" && !category) {
        if (e.target.value.includes("All ")) {
          delete temp.category
        } else {
          temp.category = e.target.value
        }
      } else if (name === "industry") {
        if (e.target.value.includes("All ")) {
          delete temp.industrysector
        } else {
          temp.industrysector = e.target.value
        }
      } else if (name === "postingType") {
        if (e.target.value.includes("All ")) {
          delete temp.postingtype
        } else {
          temp.postingtype = e.target.value
        }
      } else if (name === "jobtype") {
        if (e.target.value.includes("All ")) {
          delete temp.jobtype
        } else {
          temp.jobtype = e.target.value
        }
      } else if (name === "jobtime") {
        if (e.target.value.includes("All ")) {
          delete temp.jobtime
        } else {
          temp.jobtime = e.target.value
        }
      } else if (name === "country") {
        if (e.target.value.includes("All ")) {
          delete temp.country
        } else {
          temp.country = e.target.value
        }
      } else if (name === "companySearch") {
        if (e.target.value.includes("All ")) {
          delete temp.CompanySearch
        } else {
          temp.CompanySearch = e.target.value
        }
      } else if (name === "reset") {
        delete temp.CompanySearch
        delete temp.country
        delete temp.jobtime
        delete temp.jobtype
        delete temp.postingtype
        delete temp.industrysector
        if (!category) {
          delete temp.category
        }
        if (!region) {
          delete temp.region
        }
        delete temp.latitude
        delete temp.longitude
        delete temp.distance
        delete temp.unit

        if (document && document.getElementById("Keywords")) {
          document.getElementById("Keywords").value = ""
        }
      }

      setFilterState(temp)
    }

    function getAdvertData(jobs) {
      return Promise.all(
        jobs.slice(prevCount, currentCount).map(async id => {
          return fetchJsonp(
            "https://sf.vacancy-filler.co.uk/CareerPage/GetItem?id=" + id
          ).then(function(response) {
            return response.json()
          })
        })
      )
    }

    if (!loadMore) {
      prevCount = 0
      currentCount = 0
      setLoading(true)
    }

    try {
      fetchJsonp(
        "https://sf.vacancy-filler.co.uk/CareerPage/GetResultList?id=" +
          apiKey +
          "&" +
          "sortby=postingdate" +
          "&" +
          "sortdir=desc" +
          "&" +
          "postingtype=" +
          postingTypeSelectionValue +
          "&" +
          buildQuery(temp)
      )
        .then(function(response) {
          return response.json()
        })
        .then(async function(jsonList) {
          prevCount = currentCount
          currentCount = currentCount + 6

          await getAdvertData(jsonList).then(function(data) {
            if (loadMore) {
              setVacancy(vacancy.concat(data))
            } else {
              setVacancy(data)
            }

            if (jsonList.length === 0) {
              setVacancyTitle(
                "We couldn't find any vacancies matching your search"
              )
            } else if (jsonList.length === 0) {
              setVacancyTitle("We have " + jsonList.length + " vacancy")
            } else {
              setVacancyTitle("We have " + jsonList.length + " vacancies")
            }

            setInitialLoading(false)

            setLoading(false)
            setVacancyLoading(false)

            setLoadMoreText("Load More")
            setVacsCount(jsonList.length)
          })
        })
    } catch (error) {
      setLoading(false)
      setVacancyLoading(false)
      console.error(error.message, "error")
    }
  }

  const chooseGeoLocation = function chooseGeoLocation(lat, long, distance) {
    setAutocompleteListHide(true)
    fetchVacancies(
      filterState,
      "autocomplete",
      { lat: lat, long: long, distance: distance },
      false
    )
  }

  const renderFilter = function renderFilter(data, label, stateName) {
    if (label === "Keyword Search") {
      return (
        <div className="vf-filter">
          <label aria-label={label} htmlFor={"select-" + label}>
            {label}:{" "}
          </label>
          <input
            defaultValue={filterState[stateName]}
            onChange={e => {
              e.persist()
              keywordSearchChange(filterState, stateName, e, false)
            }}
            className="VF-form-control onchange-search form-control"
            id={"select-" + label}
            name={label}
            placeholder="Enter keywords"
            type="text"
            aria-labelledby="keywordSearchLabel"
            aria-describedby="Enter keywords"
          />
        </div>
      )
    } else if (label === "Search Location") {
      return (
        <div className="vf-filter">
          <label aria-label={label} htmlFor={"select-" + label}>
            {label}:{" "}
          </label>
          <div className="vf-filter-loc-complete-wrap">
            <input
              value={filterState[stateName]}
              onChange={e =>
                autocompleteSearchChange(filterState, label, e, false)
              }
              className="VF-form-control onchange-search form-control"
              id="Keywords"
              name="Keywords"
              placeholder="Enter postcode, town or city"
              type="text"
              aria-labelledby="keywordSearchLabel"
              aria-describedby="Enter keywords"
            />
            {!autocompleteListHide &&
              data &&
              Array.isArray(data) &&
              data.length > 0 && (
                <div className="vf-filter-loc-complete-list">
                  {data.map((loc, i) => (
                    <div
                      key={i}
                      onClick={() =>
                        chooseGeoLocation(loc.latitude, loc.longitude, 10)
                      }
                    >
                      {loc.displayName}
                    </div>
                  ))}
                </div>
              )}
          </div>
        </div>
      )
    } else {
      return (
        <div className="vf-filter">
          {/* <label aria-label={label} htmlFor={"select-" + stateName}>
            {label}{" "}
          </label> */}
          <select
            className="form-control"
            value={filterState[stateName] || data[0]}
            onChange={e => fetchVacancies(filterState, stateName, e, false)}
            name={"select-" + stateName}
            id={"select-" + stateName}
          >
            {data.map((item, i) => (
              <option key={i} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      )
    }
  }

  const clickCurrentVacancies = function clickCurrentVacancies() {
    setCareersNavState("careers")
    fetchVacancies(filterState, undefined, undefined, false, "careers")
  }

  const clickRegisterVacancies = function clickRegisterVacancies() {
    setCareersNavState("register")
    fetchVacancies(filterState, undefined, undefined, false, "register")
  }

  const clickAlertsVacancies = function clickAlertsVacancies() {
    setCareersNavState("alerts")
  }

  const loadMore = function loadMore() {
    fetchVacancies(filterState, undefined, undefined, true)
  }

  const resetVacs = function resetVacs() {
    fetchVacancies({}, "reset", undefined, false)
  }

  const searchVacs = function searchVacs() {
    fetchVacancies({}, "search", undefined, false)
  }

  const autocompleteSearchChange = function autocompleteSearchChange(
    state,
    name,
    e,
    loadMore
  ) {
    setAutocompleteListHide(false)

    let val = e.currentTarget.value

    if (e.currentTarget.value.length > 3) {
      // Do api call to get key
      fetchJsonp(
        "https://sf.vacancy-filler.co.uk/CareerPage/GetLocationAPIKey?id=" +
          apiKey
      )
        .then(function(response) {
          return response.json()
        })
        .then(function(geoKey) {
          // Do api call to get locs
          fetch(
            "https://geocoding.vacancy-filler.co.uk/api/V2/exact/?apikey=" +
              geoKey.key +
              "&search=" +
              encodeURIComponent(val)
          )
            .then(res => res.json())
            .then(result => {
              setAutoCompleteFilter(result.locationResults)
            })
        })
    }
  }

  const keywordSearchChange = function keywordSearchChange(
    state,
    name,
    e,
    loadMore
  ) {
    clearTimeout(keywordTime)

    keywordTime = setTimeout(() => {
      fetchVacancies(state, name, e, loadMore)
    }, 500)
  }

  const getSummary = function getSummary(summary, description) {
    if (summary) {
      return summary
    } else {
      let alteredDescription = description.replace(/<[^>]*>?/gm, "")
      let tempSummary = alteredDescription.substring(0, 397)
      if (tempSummary.length === 397) {
        tempSummary += "..."
      }
      return tempSummary
    }
  }

  const calculateSalary = function calculateSalary(
    Currency,
    SalaryFrom,
    SalaryTo,
    SalaryType,
    SalaryPeriod
  ) {
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    let NewSalary
    let NewSalaryFrom
    let NewSalaryTo

    let currencyFormatted = Currency

    if (Currency === "&pound;") {
      currencyFormatted = "£"
    }

    if (SalaryTo === 0) {
      NewSalary = SalaryType
    } else if (SalaryFrom === SalaryTo) {
      if (SalaryFrom >= 1000) {
        // Remove decimals
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed())
      } else {
        // Add two decimals
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed(2))
      }
      NewSalary = NewSalaryFrom + " " + SalaryPeriod
    } else {
      if (SalaryFrom >= 1000) {
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed())
      } else {
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed(2))
      }
      if (SalaryTo >= 1000) {
        NewSalaryTo = currencyFormatted + numberWithCommas(SalaryTo.toFixed())
      } else {
        NewSalaryTo = currencyFormatted + numberWithCommas(SalaryTo.toFixed(2))
      }

      NewSalary = NewSalaryFrom + " - " + NewSalaryTo + " " + SalaryPeriod
    }
    return NewSalary
  }
  const getImageFromRegionCards = function getImageFromRegionCards(region) {
    let jobCardRegionNoSpaces = region.replace(/[, ]+/g, "-")

    if (jobCardRegionNoSpaces === "Cheddar-Gorge-&-Caves") {
      return "Cheddar-Gorge-and-Caves"
    }

    return jobCardRegionNoSpaces
  }

  const FormatDateTime = function FormatDateTime(JSONDate) {
    // Set default values to avoid function breaking
    var expDate = new Date(parseInt(JSONDate.substr(6)))
    var dateFormatOptions = new Object({})
    dateFormatOptions.weekday = "long"
    dateFormatOptions.year = "numeric"
    dateFormatOptions.month = "short"
    dateFormatOptions.day = "numeric"
    return expDate.toLocaleDateString(undefined, dateFormatOptions)
  }

  const buildQuery = function buildQuery(data) {
    if (typeof data === "string") return data
    let query = []

    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        query.push(
          encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
      }
    }

    return query.join("&")
  }

  const slugify = function slugify(text) {
    return text
      .toString() // Cast to string
      .toLowerCase() // Convert the string to lowercase letters

      .trim() // Remove whitespace from both sides of a string
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
  }

  useEffect(() => {
    if (isIinitialLoad) {
      setIsIinitialLoad(false)
      if (URLSearchParams) {
        var urlParams = new URLSearchParams(window.location.search)
        var entries = urlParams.entries()
      }
      let temp = {}
      for (let pair of entries) {
        temp[pair[0]] = pair[1]
      }

      setFilterState(temp)

      const timeOut = setTimeout(() => {
        fetchVacancies(temp, undefined, undefined, false)
        if (group) {
          fetchFilters("GetLocationListByGroup", setLocationFilter, "Locations") // Locations
          fetchFilters("GetRegionListByGroup", setRegionFilter, "Regions") // Regions
          fetchFilters(
            "GetCategoryListByGroup",
            setCategoryFilter,
            "Categories"
          ) // Categories
          fetchFilters(
            "GetIndustryListByGroup",
            setIndustryFilter,
            "Industries"
          ) // Industries
          fetchFilters(
            "GetPostingTypesListByGroup",
            setPostingTypeFilter,
            "Posting Types"
          ) // Posting Types
          fetchFilters("GetJobTypeListByGroup", setJobTypeFilter, "Job Types") // Job Types
        } else {
          fetchFilters("GetLocations", setLocationFilter, "Locations") // Locations
          fetchFilters("GetRegions", setRegionFilter, "Regions") // Regions
          fetchFilters("GetCategories", setCategoryFilter, "Categories") // Categories
          fetchFilters("GetIndustries", setIndustryFilter, "Industries") // Industries
          //fetchFilters("GetPostingTypes", setPostingTypeFilter, "Posting Types") // Posting Types
          fetchFilters("GetJobTypes", setJobTypeFilter, "Job Types") // Job Types
        }
      }, 50)
      return () => clearTimeout(timeOut)
    }
  }, [careersNavState])

  return (
    <div className={vacancyLoading ? "vacancies-landing-loading" : ""}>
      {!vacancyLoading ? (
        <>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="VF_filter_form">
                  <div className="searchBlock">
                    <div id="VF-filter-form-wrapper">
                      <div
                        id="vacancies-filter-wrap"
                        className="vacancies-filters ui grid"
                        style={{ display: "block" }}
                      >
                        <div
                          id="categoryFilterWrapper"
                          className="vacancies-filter-row-item VF-filter-grid-item sixteen wide tablet six wide computer column"
                        >
                          {renderFilter(
                            categoryFilter,
                            "Select a department",
                            "category"
                          )}
                        </div>
                        <div
                          id="categoryFilterWrapper"
                          className="vacancies-filter-row-item VF-filter-grid-item sixteen wide tablet six wide computer column"
                        >
                          {renderFilter(
                            jobTypeFilter,
                            "Select a vacancy type",
                            "jobtype"
                          )}
                        </div>
                        <div
                          id="categoryFilterWrapper"
                          className="vacancies-filter-row-item VF-filter-grid-item sixteen wide tablet six wide computer column"
                        >
                          {console.log(locationFilter)}
                          {renderFilter(
                            locationFilter,
                            "Select a location",
                            "location"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="VF_container">
            <div className="container">
              <div className="inner-content grid-section box-theme-2 joblist-section col-xs-12 col-12">
                <div id="VF-vacancies-wrapper">
                  <div
                    id="VF_insert_jobs"
                    className="VF-jobs-grid-content ui stackable cards three"
                  >
                    {loading ? (
                      "Loading vacancies..."
                    ) : (
                      <>
                        {vacancy &&
                        vacancy !== [] &&
                        vacancy !== "[]" &&
                        !initialLoading ? (
                          <>
                            {vacancy && vacancy.length > 0 ? (
                              vacancy.map((job, i) => {
                                return (
                                  <div className="job-card card Sales Devonshire Hotel &amp; Restaurant Group">
                                    <div className="job-title">
                                      <Link
                                        className="header"
                                        to={
                                          "/vacancies/vacancy/" +
                                          new Buffer(job.Id).toString("base64")
                                        }
                                      >
                                        {job.CompanyGroupName}
                                        {job.JobTitle}
                                      </Link>
                                    </div>
                                    <div className="content main">
                                      <div className="short-details">
                                        <div className="location">
                                          <span>Location: </span>
                                          {job.Location}
                                        </div>
                                        <div className="department">
                                          <span>Department: </span>
                                          {job.JobCategory}
                                        </div>
                                        <div className="type">
                                          <span>Type: </span>
                                          {job.JobType}
                                        </div>
                                      </div>
                                      <div className="summary">
                                        {getSummary(
                                          job.Summary,
                                          job.Description
                                        )}
                                      </div>
                                      <div className="expiry">
                                        <span>Closing Date: </span>
                                        {FormatDateTime(job.ExpiryDate)}
                                      </div>
                                    </div>
                                    <div className="extra content">
                                      <Link
                                        className="ui button primary btn btn-two"
                                        style={{ width: "100%" }}
                                        to={
                                          "/vacancies/vacancy/" +
                                          new Buffer(job.Id).toString("base64")
                                        }
                                      >
                                        More Info
                                      </Link>
                                    </div>
                                  </div>
                                )
                              })
                            ) : (
                              <div className="job-card card job-card-no-results">
                                <div className="job-card-details">
                                  <div className="no-results">
                                    Sorry, we don't have any vacancies matching
                                    your search.
                                  </div>
                                  <button
                                    id="reset_vacs"
                                    className="ui button secondary btn btn-two"
                                    onClick={() => resetVacs()}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="no-vacancies">
                            Loading vacancies...
                          </div>
                        )}
                        <div className="load-more-wrap col-12">
                          {currentCount < vacsCount && (
                            <a
                              className="nav-action-sm"
                              role="button"
                              onClick={() => loadMore()}
                            >
                              {loadMoreText}
                            </a>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="page-loading-block"></div>
      )}
    </div>
  )
}

export default SmartFeedFiltersComponent
